module.exports = __webpack_public_path__ + "static/avma-0b3a0d0eab4fff644f6d3f0f97375641.png";